import { render } from "./RMUploadDialog.vue?vue&type=template&id=0367675c&scoped=true"
import script from "./RMUploadDialog.vue?vue&type=script&lang=js"
export * from "./RMUploadDialog.vue?vue&type=script&lang=js"

import "./RMUploadDialog.vue?vue&type=style&index=0&id=0367675c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0367675c"]])

export default __exports__